<template>
  <div v-loading="loading" style="max-height: 800px;">
    <h1>Заявка {{ requestInfo.number }}</h1>

    <Card
      class="m-b-15"
      style="display: grid; grid-template-columns: 1fr 1fr; gap: 1em;"
    >
      <div>
        <CardString
          title="Дата создания"
          :content="parseDate(requestInfo.createdAt)"
        />
        <CardString title="Тема" :content="requestInfo.subject" />
        <CardString title="Текст заявки" :content="requestInfo.message" />
        <CardString title="Статус">
          <Status
            :status="requestInfo.status"
            :change="true"
            @refresh="fetchRequestInfo"
          />
        </CardString>
      </div>
      <div>
        <CardString title="Адрес" :content="requestInfo.address" />
        <CardString title="Лицевой счет" :content="requestInfo.accountName" />
        <CardString title="E-mail" :content="requestInfo.email" />
        <CardString title="Телефон" :content="requestInfo.phone" />
      </div>
      <div>
        <CardString title="Прикрепленные файлы">
          <div style="padding-top: 8px;">
            <div v-for="file in requestInfo.attachments" :key="file.id">
              <el-link :href="file.url" type="primary" download target="_blank">
                {{ file.fileName }}
              </el-link>
            </div>
          </div>
        </CardString>
      </div>
    </Card>

    <Card v-if="requestInfo.comments.length || requestInfo.commentsAllowed">
      <div>Комментарии</div>
      <div class="comments">
        <Comment
          v-for="comment in commentsReverse"
          :key="comment.id"
          :message="comment.message"
          :attachments="comment.attachments"
          :authorType="comment.authorType"
          :createdAt="comment.createdAt"
        />
      </div>

      <CommentSender
        v-if="requestInfo.commentsAllowed"
        @refresh="fetchRequestInfo"
      />
    </Card>
  </div>
</template>

<script>
import CardString from "./components/CardString.vue";
import Card from "./components/Card.vue";
import { parseDate } from "@/plugins/dateParser";
import Comment from "./components/Comment.vue";
import CommentSender from "./components/CommentSender.vue";
import Status from "./components/Status.vue";

export default {
  components: { CardString, Card, Comment, CommentSender, Status },
  data() {
    return {
      loading: true,
      requestInfo: {
        number: "",
        createdAt: "",
        subject: "",
        message: "",
        status: null,
        address: "",
        accountId: null,
        accountName: "",
        userId: "",
        email: "",
        phone: null,
        comments: [],
        attachments: []
      }
    };
  },
  computed: {
    commentsReverse() {
      const rev = [...this.requestInfo.comments];
      rev.reverse();
      return rev;
    }
  },
  methods: {
    async fetchRequestInfo() {
      this.loading = true;
      try {
        const result = await this.$store.dispatch(
          "fetchRequest",
          this.$route.params.id
        );
        if (result) {
          this.requestInfo = result;
          await this.$store.dispatch("markAsRead", this.$route.params.id);
        }
      } catch (e) {
        this.error = this.$ErrorsMod(e);
      } finally {
        this.loading = false;
      }
    },
    parseDate(d) {
      return parseDate(d);
    }
  },
  mounted() {
    this.fetchRequestInfo();
  }
};
</script>
<style scoped>
.comments {
  margin-top: 1em;
  display: flex;
  flex-direction: column-reverse;
  gap: 1em;
  overflow: hidden auto;
  max-height: 250px;
}
</style>
